import { MAX_DECIMAL } from "../../../../common/Configurations/DecimalConfiguration";
import { WAIVED } from "../members/member/coverage/enums/memberCoverageGuaranteeTypes";

export const PREMIUM_SIMULATOR_VALIDATION_RULES = {
  employeeType: {
    isRequired: {
      value: true,
    },
  },
  memberId: {
    isRequiredTrimIfFieldHasValue: {
      value: { field: "employeeType", expectedValues: ["existing"] },
    },
  },
  payrollFrequency: {
    isRequiredTrim: {
      value: true,
    },
  },
  languageCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  lastName: {
    isRequiredTrim: {
      value: true,
    },
  },
  firstName: {
    isRequiredTrim: {
      value: true,
    },
  },
  provinceCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  classId: {
    isRequiredTrim: {
      value: true,
    },
  },
  divisionId: {
    isRequiredTrim: {
      value: true,
    },
  },
  birthdate: {
    isRequiredTrim: {
      value: true,
    },
  },
  salary: {
    isRequiredTrim: {
      value: true,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
   memberCoverageGuarantees: {
    array: {
      coverageType: {
        isRequiredTrimIfFieldsValueDoesNotEqual: {
          value: {
            expectedValues: [WAIVED.value]
          },
        }
      },
      invoicedClientRate: {
        isRequiredTrim: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      allowance: {
        isRequiredTrim: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      volume: {
        isRequiredTrim: {
          value: true,
        },
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
      formulaMspa: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
      },
    },
    atLeastOne: {
      value: {
        field: "checked",
        expectedValue: true,
        customMessageKey: "memberCoverages.validation.guaranteeSelection",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorValidationRules.js